import React, { useState } from 'react';
import styles from './toolsPanel.mod.scss';
import clsx from 'clsx';
import Prev from '../../../assets/icons/toolsPanel/prev';
import Next from '../../../assets/icons/toolsPanel/next';
import ZoomOut from '../../../assets/icons/toolsPanel/zoomOut';
import ZoomIn from '../../../assets/icons/toolsPanel/zoomIn';
import Focus from '../../../assets/icons/toolsPanel/focus';

const CreabotsToolsPanel = (props) => {

  const {
    setZoom,
    setCenter,
    setUndo,
    settingActive,
    toggleSettings,
    changeToolboxToggle,
    toolboxToggle,
    toggleDarkTheme,
    darkthemeToggle
  } = props;

  return (
    <div id="unlockToolsPanel" className={clsx(styles.toolsPanel, 'blocklyToolsPanel')}>
      <div className={styles.buttons}>
        <div className={styles.inlineBlock}>
          <button id="btn-undo-tools" type="button" className="undo2" onKeyPress={() => { }} onClick={() => setUndo(false)}>
            <Prev color='var(--color-placeholder)' />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-redo-tools" type="button" className="undo2" onKeyPress={() => { }} onClick={() => setUndo(true)}>
            <Next color='var(--color-placeholder)' />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-zoom-out-tools" type="button" className="zoom-out" onKeyPress={() => { }} onClick={() => setZoom('down')}>
            <ZoomOut color='var(--color-placeholder)' />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-zoom-in-tools" type="button" className="zoom-in" onKeyPress={() => { }} onClick={() => setZoom('up')}>
            <ZoomIn color='var(--color-placeholder)' />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-center-tools" type="button" className="center" onKeyPress={() => { }} onClick={setCenter}>
            <Focus color='var(--color-placeholder)' />
          </button>
        </div>
      </div>
    </div>
  );

};

const ToolsPanel = React.memo((props) => {
  const [settingActive, setSettingActive] = useState(false);
  const toolboxToggle = props.toolboxToggle;
  const darkthemeToggle = props.darkthemeToggle;
  const { isCreabots } = props;

  const toggleSettings = () => {
    setSettingActive(!settingActive);
  }

  const setZoom = (direction = 'up') => {
    if (props.onSetZoom) {
      props.onSetZoom(direction);
    }
  }

  const setUndo = (direction = 'up') => {
    if (props.onSetUndo) {
      props.onSetUndo(direction);
    }
  }

  const setCenter = () => {
    if (props.onSetCenter) {
      props.onSetCenter();
    }
  }

  const changeToolboxToggle = () => {
    if (props.onChangeToolboxToggle) {
      props.onChangeToolboxToggle();
    }
  }

  const toggleDarkTheme = () => {
    if (props.onToggleDarkTheme) {
      props.onToggleDarkTheme();
    }
  }

  const creabotsToolsPanelProps = {
    setZoom,
    setCenter,
    setUndo,
    settingActive,
    toggleSettings,
    changeToolboxToggle,
    toolboxToggle,
    toggleDarkTheme,
    darkthemeToggle
  }

  return isCreabots ? <CreabotsToolsPanel {...creabotsToolsPanelProps} /> : (
    <div className={clsx((!isCreabots && !darkthemeToggle) ? 'theme-aula' : '', styles.toolsPanel, 'blocklyToolsPanel')}>
      <div className={styles.buttons}>
        <div className={styles.inlineBlock}>
          <button id="btn-zoom-in-tools" type="button" className="zoom-in" onKeyPress={() => { }} onClick={() => setZoom('up')}>
            <span className="icon-zoom-in" />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-zoom-out-tools" type="button" className="zoom-out" onKeyPress={() => { }} onClick={() => setZoom('down')}>
            <span className="icon-zoom-out" />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-center-tools" type="button" className="center" onKeyPress={() => { }} onClick={setCenter}>
            <span className="icon-radio-checked" />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-undo-tools" type="button" className="undo2" onKeyPress={() => { }} onClick={() => setUndo(false)}>
            <span className="icon-undo2" />
          </button>
        </div>
        <div className={styles.inlineBlock}>
          <button id="btn-redo-tools" type="button" className="undo2 inverted" onKeyPress={() => { }} onClick={() => setUndo(true)}>
            <span className="icon-undo2" />
          </button>
        </div>
        <div className={`${styles.inlineBlock} ${(settingActive) ? styles.active : ''}`}>
          <button id="btn-settings-tools" type="button" className="zoom-in" onKeyPress={() => { }} onClick={toggleSettings}>
            <span className="icon-cog1" />
          </button>
          {(settingActive) && (
            <div className="settings tab-dropdown" onKeyPress={() => { }} onClick={toggleSettings}>
              <div className="tab-dropdown-close-clickability" />
              <ul className="tab-dropdown-options">
                <li className="tab-save" onKeyPress={() => { }} onClick={changeToolboxToggle}>
                  <span className="">
                    {(toolboxToggle) && ('Modo TXT')}
                    {(!toolboxToggle) && ('Modo ICO')}
                  </span>
                </li>
                <li className="tab-save" onKeyPress={() => { }} onClick={toggleDarkTheme}>
                  <span className="">
                    {(darkthemeToggle) && ('Modo claro')}
                    {(!darkthemeToggle) && ('Modo oscuro')}
                  </span>
                </li>
                {/* <li className="tab-save" onKeyPress={() => {}} onClick={() => { this.showHelpAgain(); }}>
                    <span className="">
                      Mostrar Ayuda
                    </span>
                  </li> */}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default ToolsPanel;